import axios from "axios";
import { closedSignerAccessRedirect } from "./signerAccessRecovery";

export const apiBaseEndpoint = () => {
  const env = process.env.REACT_APP_ENVIRONMENT;
  const version = "v1";
  const url = window.location.hostname;

  if (env === "production" && !url.startsWith("app-staging")) {
    return `https://api.assinafy.com.br/${version}`;
  } else if (env === "development") {
    // return `https://api.competent-bassi.stage.assinafy.com.br/${version}` // to has_signature test
    // return `https://api.main.stage.assinafy.com.br/${version}`;
    //return `https://api.funny-chatterjee.stage.assinafy.com.br/${version}`;
    // return `https://api.elated-rosettes.stage.assinafy.com.br/${version}`;
    return `https://api.angry-pisco.stage.assinafy.com.br/${version}`;
  }

  return `https://api.main.stage.assinafy.com.br/${version}`;
};

const accessToken = () => {
  const itemSession = localStorage.getItem("session");
  if (!itemSession) {
    return;
  }

  const currentSession = JSON.parse(itemSession || "{}");
  if (currentSession?.access_token) {
    return currentSession.access_token;
  }
};

const decodeJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

const axiosInstance = axios.create({
  baseURL: apiBaseEndpoint(),
  headers: {
    "Content-Type": "application/json",
  },
});

let isHandlingWorkspaceMembershipError = false;

const updateSessionAccounts = (accounts = []) => {
  const itemSession = localStorage.getItem("session");
  if (!itemSession) {
    return;
  }

  const currentSession = JSON.parse(itemSession || "{}");
  localStorage.setItem(
    "session",
    JSON.stringify({
      ...currentSession,
      accounts,
    })
  );
};

const isWorkspaceMembershipError = (response) => {
  const message = response?.data?.message;
  if (!message || typeof message !== "string") {
    return false;
  }

  return (
    response?.status === 403 &&
    /n[aã]o [ée] um membro ativo da conta da [aá]rea de trabalho/i.test(message)
  );
};

const recoverFromWorkspaceMembershipError = async () => {
  if (isHandlingWorkspaceMembershipError) {
    return;
  }

  isHandlingWorkspaceMembershipError = true;

  try {
    const token = accessToken();
    if (!token) {
      return;
    }

    const { data } = await axios({
      method: "GET",
      baseURL: apiBaseEndpoint(),
      url: "/accounts",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const accounts = Array.isArray(data?.data) ? data.data : [];
    updateSessionAccounts(accounts);

    if (!accounts.length) {
      if (window.location.pathname !== "/workspace/new") {
        window.location.href = "/workspace/new";
      }
      return;
    }

    if (window.location.pathname.startsWith("/dashboard")) {
      window.location.href = "/dashboard";
    }
  } finally {
    isHandlingWorkspaceMembershipError = false;
  }
};

// Add request interceptor to set Authorization header for each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = accessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    const signerRedirect = closedSignerAccessRedirect(error, window.location.pathname);
    if (signerRedirect) {
      window.location.replace(signerRedirect);
    }

    if (isWorkspaceMembershipError(response)) {
      recoverFromWorkspaceMembershipError().catch(() => {});
    }

    if (
      response &&
      response.config.url !== "/login" &&
      response.config.url !== "/authentication/social-login" &&
      response.config.url !== "/authentication/mfa/verify" &&
      response?.status === 401
    ) {
      const token = accessToken();
      if (token) {
        const jwt = decodeJwt(token);
        const currentTime = new Date().getTime();
        if (jwt.exp * 1000 < currentTime) {
          window.location.href = "/logout";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

export const cancelRequest = () => {
  // const controller = new AbortController();
  const source = axios.CancelToken.source();

  return {
    cancel: () => {
      // controller.abort();
      source.cancel();
    },
    config: {
      // signal: controller.signal,
      cancelToken: source.token,
    },
  };
};
